import React from 'react'
import styled from 'styled-components'

export const DesktopMenu = () => {
  return (
    <DesktopMenuStyles>
      <nav className='desktop-menu'>
        <ul className='desktop-menu__nav-list'>
          <li className='desktop-menu__nav-list__option'>
            <a href='/'>Inicio</a>
          </li>
          <li className='desktop-menu__nav-list__option'>
            <a href='#soluciones'>Soluciones</a>
          </li>
          <li className='desktop-menu__nav-list__option'>
            <a href='#soporte'>Soporte</a>
          </li>
          <li className='desktop-menu__nav-list__option'>
            <a href='#objetivo'>Objetivo</a>
          </li>
          <li className='desktop-menu__nav-list__option'>
            <a href='#contacto'>Contacto</a>
          </li>
        </ul>
      </nav>
    </DesktopMenuStyles>
  )
}

const DesktopMenuStyles = styled.div`
  width: 100%;
  display: none;
  @media (min-width: ${({theme}) => theme.large.start}) {
    display: block;
  }

  .desktop-menu {
    &__nav-list {
      font-size: 25px;
      margin: 0;
      margin-top: 25px;
      padding: 0px;
      list-style-type: none;
      display: flex;
      justify-content: space-around;

      &__option {
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }

        a {
          color: inherit;
          text-decoration: none;
        }
      }
    }
  }
`




// WEBPACK FOOTER //
// ./src/components/DesktopMenu.js